<template>
    <f7-page name="Renewal details">
        <f7-navbar
            large
            title-large="Renewal details"
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="goBack"
                />
            </f7-nav-left>
            <f7-nav-title>Renewal details</f7-nav-title>
        </f7-navbar>

        <f7-block style="background: white; color: black; padding: 10px 16px;text-align: left">
            <div v-if="isApple">
                <h3>General</h3>
                <p>
                    – Payment will be charged to iTunes Account at confirmation of purchase<br>
                    – Subscription automatically renews unless auto-renew is turned off at least 24-hours before the end of the current period<br>
                    – Account will be charged for renewal within 24-hours prior to the end of the current period, and identify the cost of the renewal<br>
                    – Subscriptions may be managed by the user and auto-renewal may be turned off by going to the user's Account Settings after purchase<br>
                    – <a
                        href="/privacy"
                        style="text-decoration: underline"
                    >Privacy Policy</a> and <a
                        href="/termsOfUse"
                        style="text-decoration: underline"
                    >Terms of Use apply</a><br>
                    – Any unused portion of a free trial period, if offered, will be forfeited when the user purchases a subscription to that publication, where applicable
                </p>
            </div>
            <div v-else-if="isAndroid">
                <h3>General information</h3>
                <p>
                    – Payment will be charged to Google Play at confirmation of purchase.<br>
                    – Subscription automatically renews unless auto-renew is cancelled at least 24-hours before the end of the current period<br>
                    – Account will be charged for renewal within 24-hours prior to the end of the current period, and identify the cost of the renewal<br>
                </p>
            </div>
            <div v-else>
                <h3>General information</h3>
                <p>
                    You will be charged the full subscription price via Stripe after your one-week trial has completed unless auto-renew is cancelled at least 24 hours before the end of the trial period.
                    Payment will renew automatically at the end of the subscription period unless auto-renew is cancelled at least 24 hours before the end of the period.
                </p>
            </div>
            <br>
            <h3>FAQ</h3>
            <h3>I paid for a subscription but it is not working</h3>
            <p>
                Try pressing "Restore purchase." Make sure you are logged in with the email you puchased your subscription with.
            </p>
            <h3>How do I cancel my subscription?</h3>
            <p> First you must find out how you subscribed. This can be found in settings.<br><br>
                If you subscribed oon iOS via the App Store (<a
                    href="https://support.apple.com/en-gb/HT202039"
                    target="_system"
                    style="text-decoration: underline"
                    class="external"
                >here</a>) <span v-if="!isPgap || isAndroid"> but if you're on Android you must visit your settings in the Google Play Store.<br><br>
                    Web and desktop subscriptions can be cancelled via Stripe</span>.
            </p>
            <br>
            See our full legal terms <f7-link href="/termsOfUse">here</f7-link>

        </f7-block>

    </f7-page>
</template>

<script>
export default {
    store: ['api'],
    data () {
        return {};
    },
    computed: {
        device: function () {
            return f7.device;
        },
        isPgap: function () {
            return !!pgap;
        },
        isApple: function () {
            return pgap && device.platform === 'iOS';
        },
        isAndroid: function () {
            return pgap && device.platform === 'Android';
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        goBack: function () {
            if (f7.views['main'].router.history.length === 1) {
                return f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            }
            return f7.views['main'].router.back();
        }
    }
};
</script>

<style lang="less" scoped>
.center {
    text-align: center;
}
</style>
